// @storybook-skip: internal building block of the lesson carousel cards; covered by their stories
import type { ReactNode } from "react";
import { Card } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";
import { FlatCard } from "../Cards/FlatCard";
import { supabaseImageUrlParser } from "../CustomImage";

type Props = {
	cardWidth: number;
	thumbnailUrl?: string;
	coverOverlay?: ReactNode;
	onPress: () => void;
	children: ReactNode;
};

export const LessonCardShell = ({
	cardWidth,
	thumbnailUrl,
	coverOverlay,
	onPress,
	children,
}: Props) => {
	const theme = useAppTheme();
	const coverUri = thumbnailUrl
		? supabaseImageUrlParser({ src: thumbnailUrl, width: cardWidth })
		: undefined;

	return (
		<FlatCard
			style={{
				maxWidth: cardWidth,
				overflow: "hidden",
				borderWidth: 1,
				borderColor: theme.colors.outlineVariant,
			}}
			onPress={onPress}
		>
			{coverUri ? (
				<Box position="relative" justifyContent="center">
					<Card.Cover
						source={{ uri: coverUri }}
						style={{
							borderBottomLeftRadius: 0,
							borderBottomRightRadius: 0,
							aspectRatio: 16 / 9,
							height: cardWidth * 0.5625,
							backgroundColor: theme.colors.surfaceVariant,
						}}
					/>
					{coverOverlay}
				</Box>
			) : null}
			<Card.Content style={{ paddingTop: 16 }}>{children}</Card.Content>
		</FlatCard>
	);
};
